module.exports = __webpack_public_path__ + "pc/img/notice-ceo-signature.7889e791.png";